// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function isDate(date: any): date is Date {
	if (typeof date === "string") {
		date = new Date(date);
	}
	return !!(date && date !== "Invalid Date" && !isNaN(date) && typeof date.getMonth === "function");
}
